import { useEffect } from 'react';
import SDK from '@ygoargentina/sdk/api';
import { useCardStore } from '@/store/cards';
import { useUserStore } from '@/store/users';
import { useAuthQuery } from './use-auth-query';

/**
 * Carga el catálogo completo de cartas (`['cards']`) y lo guarda en el store.
 *
 * Comparte cache de React Query con cualquier otro consumidor de la misma
 * queryKey, así que llamarlo al entrar a una pantalla precarga el listado para
 * cuando luego se abra un selector de cartas.
 */
export function useCards() {
  const { user } = useUserStore();
  const { cards, setCards } = useCardStore();

  const { isPending, data } = useAuthQuery({
    queryKey: ['cards'],
    queryFn: () => SDK.Cards.listCards(user, { limit: 0 }),
  });

  useEffect(() => {
    const fetched = data?.data?.data;
    if (!fetched?.length) return;

    // El store está persistido en localStorage, así que hay que re-sincronizarlo
    // cuando el catálogo cambia (ej: se agregan cartas de un set nuevo). Si sólo
    // populáramos cuando está vacío, un catálogo viejo cacheado nunca se
    // actualizaría y las cartas nuevas no aparecerían en el selector.
    if (fetched.length !== cards.length) {
      setCards(fetched);
    }
  }, [cards.length, data, setCards]);

  return {
    cards,
    // Sólo es "loading" real cuando no hay nada que mostrar todavía.
    isLoading: cards.length === 0 && isPending,
  };
}

export default useCards;
